import { Badge, Icon } from "@nabble/ui";

/** The two second factors a person can enroll first. */
export function MethodChoice({ onTotp, onPasskey }: { onTotp: () => void; onPasskey: () => void }): React.JSX.Element {
  return (
    <div className="nb-choice-list">
      <button type="button" className="nb-choice" aria-label="Use an authenticator app (TOTP)" onClick={onTotp}>
        <span className="nb-choice-icon">
          <Icon name="smartphone" />
        </span>
        <span className="nb-choice-body">
          <span className="nb-choice-title">
            Authenticator app <Badge label="Recommended" tone="info" dot={false} />
          </span>
          <span className="nb-choice-desc">Google Authenticator, Microsoft Authenticator, 1Password or another app with 6-digit codes.</span>
        </span>
        <Icon name="chevronRight" className="nb-choice-go" />
      </button>
      <button type="button" className="nb-choice" aria-label="Use a passkey" onClick={onPasskey}>
        <span className="nb-choice-icon">
          <Icon name="key" />
        </span>
        <span className="nb-choice-body">
          <span className="nb-choice-title">Passkey</span>
          <span className="nb-choice-desc">Face ID, Touch ID, Windows Hello or a security key. It stays linked to this device.</span>
        </span>
        <Icon name="chevronRight" className="nb-choice-go" />
      </button>
    </div>
  );
}
